import React from 'react';
import { Check } from 'lucide-react';
import { CardPayment } from '@mercadopago/sdk-react';
import v2SubscriptionsApi from '../../../api/v2subscriptions';
import { useAuth } from 'components/context/AuthContext';
import { logApi } from 'api';
import GenericModal from 'components/modals/GenericModal';

const { createLog } = logApi;

const SubscriptionModal = ({ isOpen, onClose, onSuccess, onError, plan }) => {
  const { auth } = useAuth();

  const initialization = {
    amount: plan?.amount || 0,
    payer: {
      email: auth.user.email
    }
  };

  const handleSubscription = async (formData) => {
    createLog({
      level: 'info',
      message: 'Click en "Confirmar suscripción" en SubscriptionModal'
    });
    try {
      const MP_DEVICE_SESSION_ID = window.MP_DEVICE_SESSION_ID;
      const subscriptionResponse = await v2SubscriptionsApi.subscribe(plan.id, { 
        mp_device_session_id: MP_DEVICE_SESSION_ID, 
        token: formData.token 
      });
      onSuccess(subscriptionResponse.id, `Felicitaciones! Estás suscrito al plan ${plan.reason}`);
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error?.response?.data?.message || error?.message;
      const errorCode = error?.response?.data?.code;
      const errorCodeMessage = errorCode ? ` Código de error: ${errorCode}` : '';
      createLog({
        level: 'error',
        message: `Error pagando plan ${plan.reason} para usuario ${auth.user.email}: ${errorMessage}.${errorCodeMessage}`
      });
      onError(`Error: ${errorMessage}.${errorCodeMessage}`);
    }
  };

  const onBrickError = (error) => {
    console.error('Brick error:', error);
    onError('Error en el formulario: ' + error.message);
  };

  const onReady = () => {
    createLog({
      level: 'info',
      message: 'Cargó Brick de Mercado Pago'
    });
  };

  if (!isOpen) return null;
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640

  return (
    <GenericModal
      isOpen={isOpen}
      toggle={onClose}
      title={`Confirmar Suscripción a ${plan?.reason}`}
      closable
      width="600px"
      contentPadding="0 2.5rem 2rem 2.5rem"
      maxHeight={isMobile ? '60vh' : '100vh'}
      showLogo={false}
      className="z-[10001]"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Left Column - Plan Information */}
        <div className="hidden md:block backdrop-blur-md bg-white/10 border border-white/20 p-4 rounded-lg">
          <div className="space-y-2">
            <p className="text-white font-semibold">
              {`${plan?.display_price} ${plan?.display_frequency}`}
              <span className="text-xs text-white/60 font-normal">
                &nbsp; *cobrados en moneda local
              </span>
            </p>
            {plan?.features && plan.features.length > 0 && (
              <div className="mt-4">
                <ul className="space-y-2">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <div className="flex-shrink-0">
                        <Check className="w-4 h-4 text-green-400 mt-0.5" />
                      </div>
                      <span className="text-sm text-white/80 ml-2">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* Right Column - Payment Form */}
        <div>
          <div className="mb-3">
            <CardPayment
              initialization={initialization}
              customization={{
                visual: {
                  style: {
                    theme: 'default',
                  },
                },
                paymentMethods: {
                  maxInstallments: 1,
                  types: {
                    credit: true,
                    debit: true,
                  },
                },
              }}
              onSubmit={handleSubscription}
              onReady={onReady}
              onError={onBrickError}
            />
          </div>
        </div>
      </div>
    </GenericModal>
  );
};

export default SubscriptionModal;
